import { Card, PageHeader } from '@central/ui';
import { useQuery } from '@tanstack/react-query';
import { deploymentsQuery } from '../api';
import { DeploymentGrid } from '../components/DeploymentCardView';
import { QueryState } from '../components/QueryState';
import { StripLegend } from '../components/StripLegend';

export function Deployments() {
  const { data, error } = useQuery(deploymentsQuery);
  return (
    <>
      <PageHeader title="Deployments" subtitle="Every GoATMS environment your organization uses." />
      {!data ? (
        <QueryState error={error} />
      ) : data.items.length > 0 ? (
        <>
          <DeploymentGrid items={data.items} />
          <StripLegend />
        </>
      ) : (
        <Card>No deployments are reporting to Central yet.</Card>
      )}
    </>
  );
}
